export const SET_TOOLS_LIST = 'tools/SET_TOOLS_LIST'
export const SET_TYPE_TOOLS_LIST = 'tools/SET_TYPE_TOOLS_LIST'
export const SET_MANAGE_TOOL = 'tools/SET_MANAGE_TOOL'
export const SET_MANAGE_TYPE_TOOL = 'tools/SET_MANAGE_TYPE_TOOL'
